import { TrackerAnalyzeIngredientConnectorApollo } from '@front-activerse/common-components';
import TrackerAddIngredientContainer from './TrackerAddIngredientContainer';
import { useLocation } from 'react-router-dom';

interface AnalyzeIngredientInput {
  description: string;
  baseAmount: number;
  baseUnit: string;
}

interface AnalyzeIngredientResponse {
  __typename: string;
  primaryIngredient: {
    productId: string;
    name: string;
    baseAmount: number;
    baseUnit: string;
    calories: number;
    proteinGrams: number;
    carbsGrams: number;
    fatGrams: number;
  };
}

const TrackerIndexPage = () => {
  const location = useLocation();

  return (
    <TrackerAnalyzeIngredientConnectorApollo>
      {({
        analyzeIngredient,
        cancelAnalyzeIngredient,
      }: {
        analyzeIngredient: (input: AnalyzeIngredientInput) => Promise<AnalyzeIngredientResponse>;
        cancelAnalyzeIngredient: () => void;
      }) => (
        <TrackerAddIngredientContainer
          analyzeIngredient={analyzeIngredient}
          cancelAnalyzeIngredient={cancelAnalyzeIngredient}
          key={location.key}
        />
      )}
    </TrackerAnalyzeIngredientConnectorApollo>
  );
};

export default TrackerIndexPage;
